export const USAGE_AREAS = ["Worldwide", "APAC", "EMEA", "LATAM", "NAFTA", "Europe", "Western Europe", "Eastern Europe"];